<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Income</h3>
          <v-btn icon color="primary" @click="openInForm" class="elevation-5">
            <v-icon>add</v-icon>
          </v-btn>

          <!-- <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn color="success" @click="exportAllIncome()" v-on="on">Excel</v-btn>
            </template>
            <span>Export all income this term to excel</span>
          </v-tooltip> -->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-data-table
                :headers="inc_headers"
                :items="incomes"
                class="elevation-0"
                :search="search"
                :loading="loading"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">{{ props.index + 1 }}</td>
                  <td
                    class="text-xs-center"
                  >{{ props.item.ledgeracc&&props.item.ledgeracc.name?props.item.ledgeracc.name:'N/A' }}</td>
                  <td class="text-xs-center">{{ props.item.description }}</td>
                  <td class="text-xs-center">{{ props.item.amount | currency }}</td>
                  <td class="text-xs-center">{{ props.item.jdate }}</td>
                  <td class="text-xs-center">{{ props.item.recorded_by.name }}</td>

                  <td class="text-xs-center">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-btn text icon color="blue" @click="editincome(props.item)">
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn text icon color="pink" @click="deleteincome(props.item,props.index)">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!--dialog form to add and edit income begins-->
      <inc-dialog ref="incfm">
        <template v-slot:modal-title>{{fm_title}}</template>

        <template v-slot:modal-content>
          <v-form ref="form">
            <v-autocomplete
              :items="ledgeraccs"
              item-text="name"
              item-value="id"
              label="Ledger Account"
              prepend-icon="book"
              v-model="income_model.ledgeracc_id"
              :rules="valid_rules.required"
            />
            <v-text-field
              label="Description/Reference"
              prepend-icon="description"
              v-model="income_model.description"
              :rules="valid_rules.required"
            />

            <v-text-field
              label="Amount"
              v-model="income_model.amount"
              :rules="valid_rules.required"
              prepend-icon="money"
              type="number"
              step="any"
            />

            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="income_model.jdate"
              persistent
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="income_model.jdate"
                  label="Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  :rules="valid_rules.required"
                ></v-text-field>
              </template>
              <v-date-picker v-model="income_model.jdate" scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(income_model.jdate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-form>
        </template>

        <template v-slot:modal-actions>
          <v-btn class="error" text @click.stop="closeInForm()">Close</v-btn>
          <v-btn class="success" text @click="saveincome();">Save</v-btn>
        </template>
      </inc-dialog>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "../shared/modal_dialog";
import { json2excel, excel2json } from "js2excel";
export default {
  layout: "accounts",
  name: "incomes-view",
  metaInfo() {
    return { title: this.$t("incomes") };
  },
  components: {
    "inc-dialog": Modal
  },
  data() {
    return {
      editedIndex: -1,
      search: "",
      showD: false,
      modal: false,
      fm_title: "",
      valid_rules: {
        required: [v => !!v || "this field is required"]
      },
      income_model: {
        ledgeracc_id: "",
        description: "",
        amount: "",
        jdate: new Date().toISOString().substr(0, 10)
      },
      income_modelcp: {
        name: "",
        description: "",
        amount: "",
        jdate: new Date().toISOString().substr(0, 10)
      },
      inc_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "level"
        },
        {
          text: "Ledger Account",
          align: "center",
          sortable: false,
          value: "income.name"
        },
        {
          text: "Description/Ref.",
          align: "center",
          sortable: false,
          value: "description"
        },
        {
          text: "Amount",
          align: "center",
          sortable: true,
          value: "amount"
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "jdate"
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: false,
          value: "recorded_by.name"
        },

        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("incomes/getAll");
  },
  computed: {
    ...mapGetters({
      incomes: "incomes/INCOMES",
      ledgeraccs: "incomes/INCOME_LEDGERACCS",
      inerrors: "incomes/INCOME_ERROR",
      loading: "incomes/INCOME_LOADING"
    })
  },
  methods: {
    exportAllIncome() {
      if (!confirm("Click okay to confirm list export or cancel.")) {
        //confirm you want to send this reminder
        return;
      }

      let data = this.incomes.map(s => {
        return {
          "Ledger Account": s.ledgeracc.name,
          Description: s.description,
          Amount: s.amount,
          Date: s.jdate,
          "Recorded By": s.recorded_by ? s.recorded_by.name : "N/A"
        };
      });

      try {
        json2excel({
          data,
          name: "incomes-" + new Date().toISOString().substr(0, 10),
          formateDate: "yyyy/mm/dd"
        });
      } catch (e) {
        console.error("export error");
      }
    },
    addincome() {
      this.$store.dispatch("incomes/add", this.income_model);

      if (this.inerrors == null) {
        this.$toast.success("Income added successfully");

        this.income_model = {
          ledgeracc_id: "",
          description: "",
          amount: "",
          jdate: new Date().toISOString().substr(0, 10)
        };
      }
    },
    deleteincome(income, index) {
      if (confirm("Are you sure you want to delete this income?")) {
        this.$store.dispatch("incomes/delete", { income, index });
        this.$toast.success("Income deleted successfully");
      }
    },

    editincome(income) {
      this.editedIndex = this.incomes.indexOf(income);
      this.income_model = Object.assign({}, income);

      //alert(this.editedIndex)

      this.openInForm()
    },
    updateincome(income, index) {
      this.$store.dispatch("incomes/update", { index, income });

      if (this.inerrors == null) {
        this.editedIndex = -1;
        this.showD = false;
        this.$toast.success("Income updated successfully");

        this.income_model = {
          ledgeracc_id: "",
          description: "",
          amount: "",
          jdate: new Date().toISOString().substr(0, 10)
        };

        this.closeInForm()
        //this.$store.dispatch("incomes/getAll", { type: 1 });

        //  setTimeout(()=>{
        //    window.location.reload();
        //  },100)
      } else {
        this.$toast.error(
          "Sorry, an error occured and income data could not be updated."
        );
      }
    },
    saveincome() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing income info or saving income info
      if (this.editedIndex > -1) {
        this.updateincome(this.income_model, this.editedIndex);
      } else {
        this.addincome();
      }
    },

    openInForm() {
      var vm = this;
      if (this.editedIndex > -1) {
        this.fm_title = "Edit Income Account";
      } else {
        this.fm_title = "Add Income Account";
      }
      vm.$refs.incfm.IsPersistent();

      vm.$refs.incfm.open();
    },
    closeInForm() {
      var vm = this;
      this.income_model = {
        ledgeracc_id: "",
        description: "",
        amount: "",
        jdate: new Date().toISOString().substr(0, 10)
      };

      vm.$refs.incfm.close();
    }
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.income_model = {
          ledgeracc_id: "",
          description: "",
          amount: "",
          jdate: new Date().toISOString().substr(0, 10)
        };
      }
    }
  }
};
</script>